export const getOrderIdLineItemMap = (data, volumeUnitConverter) => {
  const valueMap = {
    S: { volume: 194400, weight: 23.19809731 },
    M: { volume: 264132, weight: 31.51934074 },
    L: { volume: 461656.8, weight: 55.09032599 },
    RC: { volume: 7164.180015, weight: 84.31541786 },
    PL: { volume: 12960001000, weight: 1000 },
  };

  return {
    orderId: data["CUSTOMER_ORDER_NO"] || null,
    data: {
      id: data["ITEMCD"],
      name: data["ITEMNAME"],
      lineItemId: data["ITEMCD"],
      quantity: parseInt(data["ITEMQUANTITY"]),
      quantityUnit: data["ITEMQUANTITUNIT"],
      price: {
        amount: data["ITEMAMOUNT"],
        currency: data["ITEMCURRENCY"],
      },
      parts: [
        {
          volume: {
            value:
              valueMap[String(data?.["ITEMNAME"])]?.volume *
                parseInt(data["ITEMQUANTITY"]) || data["ITEMVOLUME"],
            unit: "CCM",
          },
          weight: {
            value:
              valueMap[data?.["ITEMNAME"]]?.weight *
                parseInt(data?.["ITEMQUANTITY"]) || data["ITEMWEIGHT"],
            unit: "MG",
          },
        },
      ],
    },
  };
};
